import React from "react";

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends React.Component<
  Props,
  State
> {
  constructor(props: Props) {
    super(props);

    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError(
    error: Error
  ) {
    return {
      hasError: true,
      error,
    };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-[var(--surface-1)]">
          <div className="rounded-xl border border-white/10 p-6">
            <h1 className="mb-2 text-xl font-bold">
              Something went wrong
            </h1>

            <p className="mb-4 text-sm text-white/70">
              {
                this.state.error
                  ?.message
              }
            </p>

            <button
              onClick={() =>
                window.location.reload()
              }
              className="rounded-lg border px-4 py-2"
            >
              Reload
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;